import { error as errorReducer } from './Error.reducer';
import {
    CUSTOMERTRIPS_RECEIVE,
    CUSTOMERTRIPS_ERROR
} from '../Actions/CustomerTrips.action';

const defaultState = {
    customerTripData: [],
    errors: {},
};

export const customerTrips = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CUSTOMERTRIPS_RECEIVE:
            return {
                ...state,
                errors: {},
                customerTripData: payload.data,
            };
        case CUSTOMERTRIPS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
